import React, { useState } from "react";
import { motion } from "framer-motion";
import { apiUrl } from "../utils/Configuration";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { FailMessage, Loading } from "../common/APICommon";

export default function Login({ isAuthenticated, setIsAuthenticated }) {
  const navigate = useNavigate();
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [failMessage, setFailMessage] = useState("");

  const handleLogin = async (e) => {
    e.preventDefault();

    const data = { username, password };

    try {
      setLoading(true);
      const response = await axios.post(`${apiUrl}/api/User/login`, data, {
        headers: { "Content-Type": "application/json" },
      });

      localStorage.setItem("accountData", JSON.stringify(response.data));
      localStorage.setItem("isAuthenticated", "true");
      setIsAuthenticated(true);
      navigate("/dashboard");
    } catch (error) {
      console.error("Login error:", error);
      const errorMessage = error?.response?.data?.message || "Something went wrong";
      setFailMessage(`Failed to login: ${errorMessage}`);
    } finally {
      setLoading(false);
    }
  };

  const isTest = false
  const handleLoginTest = async (e) => {
    e.preventDefault();

    if(username === "admin" && password === "password"){
      const accountData = {
        borrowerBorrowerName: "Admin",
        accessTemplate: {
          hasDashboard: true,
          hasSettings: true,
          hasGetHelp: true,
        },
      };

      localStorage.setItem("isAuthenticated", "true");
      localStorage.setItem("accountData", JSON.stringify(accountData));
      setIsAuthenticated(true);
      navigate("/dashboard");
    } else {
      setFailMessage(`Failed to login: Invalid username or password`);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-100 relative">
      {/* Background Shapes */}
      <div className="absolute inset-0 overflow-hidden pointer-events-none">
        <div className="absolute w-96 h-96 bg-theme-color opacity-10 rounded-full -top-20 -left-20 blur-3xl"></div>
        <div className="absolute w-80 h-80 bg-theme-color-light opacity-10 rounded-full bottom-0 right-0 blur-3xl"></div>
      </div>

      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5 }}
        className="w-full max-w-md bg-white/80 backdrop-blur-xl shadow-xl rounded-2xl p-10 border border-gray-200"
      >
        <div className="text-center mb-10">
          <img alt="LoanManSys Logo" src="/main_logo.png" className="w-48 mx-auto mb-4" />
          {/* <h1 className="text-3xl font-bold text-gray-800 tracking-tight">FINEX.PH</h1> */}
          <p className="text-gray-500 mt-1 text-sm">Modern Accounting System</p>
        </div>

        <form onSubmit={isTest ? handleLoginTest : handleLogin} className="space-y-6">
          <div>
            <label className="text-sm font-semibold text-gray-700">Username</label>
            <input
              type="text"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              placeholder="Enter username"
              className="w-full px-4 py-3 bg-gray-50 rounded-xl border border-gray-300 focus:ring-2 focus:ring-theme-color/60 focus:outline-none shadow-sm"
              required
            />
          </div>

          <div>
            <label className="text-sm font-semibold text-gray-700">Password</label>
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="Enter password"
              className="w-full px-4 py-3 bg-gray-50 rounded-xl border border-gray-300 focus:ring-2 focus:ring-theme-color/60 focus:outline-none shadow-sm"
              required
            />
          </div>

          <button
            type="submit"
            className="w-full py-3 rounded-xl bg-theme-color text-white font-semibold shadow-md hover:shadow-lg transition-all duration-200 hover:bg-theme-color-h"
          >
            Sign In
          </button>
        </form>

        <p className="text-center mt-8 text-gray-400 text-xs">© 2025 QS.IT. All rights reserved.</p>
      </motion.div>

      {/* Error / Loading */}
      <div className="fixed top-5 right-5 z-50 flex flex-col space-y-2">
        <FailMessage message={failMessage} onClose={() => setFailMessage("")} />
      </div>
      {loading && <Loading />}
    </div>
  );
}
